import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthWebService } from 'app/services/authweb.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-resend-registration',
  templateUrl: './resend-registration.component.html',
  styleUrls: ['./resend-registration.component.scss']
})
export class ResendRegistrationComponent implements OnInit {

  aUser: any = {};
  isPhonePortrait = false;
  email: string;
  communicationType : string;
  timeLeft: number = 60;
  interval;
  mobile : string;
  showButton: boolean = true;
  showTimer= false;
  value : string;
  private sub: any;
  
  constructor(public authWebService: AuthWebService , private responsive: BreakpointObserver, private route : ActivatedRoute) { }

  ngOnInit(): void {
    this.responsive.observe([
			Breakpoints.HandsetLandscape,      
			Breakpoints.TabletLandscape,
			])
			.subscribe(result => {
	  
			 
				this.isPhonePortrait = false; 
	  
			  if (result.matches) {
				this.isPhonePortrait = true;
			  }
			});
    this.communicationType = this.route.snapshot.paramMap.get('communicationType');
    this.value = this.route.snapshot.paramMap.get('value');
    this.email = this.route.snapshot.paramMap.get('email');
    this.mobile = this.route.snapshot.paramMap.get('mobile');

  }
  onShowButtonClick(){
    this.showButton =true;
  }

  resend(){

    this.timeLeft = 60;
    this.aUser.CommunicationType = this.communicationType;
    this.aUser.Mobile = this.mobile;
    this.aUser.email = this.email;
    this.aUser.EmailAddress = this.email;

    console.log(this.aUser);

    this.authWebService.resendregister(this.aUser);

    this.showTimer = true;
    this.showButton = false;
    this.interval = setInterval(() => {
      if(this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.timeLeft = 60;
      }
      if(this.timeLeft == 0){
        this.showButton = true;
        this.showTimer = false;
      }
    },1000)



  }



  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
